import React from "react";
import { formatPhoneDisplay, normalizeIndianPhone } from "../utils/phone";

const whatsappPhone = (value = "") => normalizeIndianPhone(value).replace(/^\+/, "");
const canUseWhatsapp = (value = "") => {
  const normalized = normalizeIndianPhone(value);
  const digits = normalized.replace(/\D/g, "");

  return /^\+91\d{10}$/.test(normalized) || (normalized.startsWith("+") && digits.length >= 10 && digits.length <= 15);
};

export default function PhoneActions({ phone = "", whatsappPhone: whatsappPhoneProp = "", className = "" }) {
  const cleanedPhone = normalizeIndianPhone(phone);
  const cleanedWhatsapp = whatsappPhoneProp ? whatsappPhone(whatsappPhoneProp) : whatsappPhone(phone);
  const primaryPhone = cleanedPhone || cleanedWhatsapp;
  const displayPhone = formatPhoneDisplay(phone || whatsappPhoneProp);
  const showWhatsapp = canUseWhatsapp(whatsappPhoneProp || phone);

  if (!primaryPhone || primaryPhone === "+") {
    return <span className={className}>{displayPhone || primaryPhone || phone || "-"}</span>;
  }

  return (
    <div className={`space-y-2 ${className}`.trim()}>
      <p>{displayPhone}</p>
      <div className="flex flex-wrap gap-2">
        <a
          href={`tel:${primaryPhone}`}
          className="inline-flex items-center rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700 transition hover:bg-emerald-200"
        >
          Call
        </a>
        {showWhatsapp ? (
          <a
            href={`https://wa.me/${cleanedWhatsapp}`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700 transition hover:bg-green-200"
          >
            WhatsApp
          </a>
        ) : null}
      </div>
    </div>
  );
}
